import { Form, Formik } from 'formik';
import { isEqual } from 'lodash';
import { TransactionConfigContainer } from './transactionConfigStyled';
import FormSelect from '../../../components/dropdown/formSelect';
import {
  useGetTransactionAcquisitionOptions,
  useGetTransactionConfiguration,
  useGetTransactionIntendedShareRegistrationsOptions,
  useWealthlaneAwardApi,
} from '../../../hooks';
import Button from '../../../components/button';
import InputText from '../../../components/input-text/inputText';
import InitialValuesForm from '../../../constants/initialValues';
import usePostTransactionConfiguration from '../../../hooks/post/usePostTransactionConfiguration';
import Spinners from '../../../components/spinner';
import { COLORS } from '../../../constants/style/color';
import { PageHeader } from '../company-profile/profile.styled';
import Heading from '../../../components/typography';
import { CommaFormatted, CommaFormattedFloatPost } from '../../../utils/global';
import { TRANSACTION_CONFIGURATION_VALIDATION } from '../../../utils/validations/validations';

const TransactionConfig = () => {
  const { handleRequest } = useWealthlaneAwardApi();
  const { data: transactionAcquisitionOptions, isLoading: transactionAcquisitionOptionsLoading } =
    useGetTransactionAcquisitionOptions(handleRequest);
  const {
    data: transactionIntendedShareRegistrationsOptions,
    isLoading: transactionIntendedShareRegistrationsOptionsLoading,
  } = useGetTransactionIntendedShareRegistrationsOptions(handleRequest);

  const { mutate, isLoading } = usePostTransactionConfiguration(handleRequest);

  const handleSubmitRsu = (values: any) => {
    const updatedValues = {
      ...values,
      priceThreshold: values?.priceThreshold
        ? Number(values?.priceThreshold?.replaceAll(',', ''))
        : '',
    };
    mutate(updatedValues);
  };

  const { data: transactionConfiguration, isLoading: transactionConfigurationLoading } =
    useGetTransactionConfiguration(handleRequest);

  return (
    <>
      <PageHeader>
        <Heading variant='h3' title='Transaction Configuration' />
        <Heading variant='body-s' title='Set up transaction configuration.' color={COLORS.Gray} />
      </PageHeader>
      <TransactionConfigContainer>
        {transactionConfigurationLoading ? (
          <div className='flex justify-center items-center'>
            <Spinners />
          </div>
        ) : (
          <Formik
            initialValues={
              transactionConfiguration
                ? {
                    ...transactionConfiguration,
                    priceThreshold: transactionConfiguration?.priceThreshold
                      ? CommaFormatted(String(transactionConfiguration?.priceThreshold))
                      : '',
                  }
                : InitialValuesForm.transactionConfig
            }
            validationSchema={TRANSACTION_CONFIGURATION_VALIDATION}
            enableReinitialize
            onSubmit={(values) => {
              handleSubmitRsu(values);
            }}>
            {({ touched, errors, setFieldValue, handleChange, values }) => {
              return (
                <Form id='transaction-config-form'>
                  <div className='grid lg:grid-cols-12 md:grid-cols-1 gap-x-8 '>
                    <div className='lg:col-span-4 col-span-1 '>
                      <InputText
                        type='text'
                        label='Price Threshold'
                        name='priceThreshold'
                        onChange={(e: any) => {
                          handleChange(e);
                        }}
                        onBlur={(e: any) => {
                          CommaFormattedFloatPost(e.target.value, 'priceThreshold', setFieldValue);
                        }}
                        errors={errors}
                        touched={touched}
                        required
                      />
                    </div>
                    <div className='lg:col-span-4 col-span-1 '>
                      <FormSelect
                        type='text'
                        label={'Acquisition Type'}
                        name={`transactionAcquisitionTypeId`}
                        onChange={(value: string) => {
                          handleChange(value);
                        }}
                        errors={errors}
                        touched={touched}
                        options={transactionAcquisitionOptions}
                        isLoading={transactionAcquisitionOptionsLoading}
                        values={values}
                        arrValue={values?.transactionAcquisitionTypeId}
                        setFieldValue={setFieldValue}
                        containerClassName='formGroup'
                        required
                      />
                    </div>
                    <div className='lg:col-span-4 col-span-1 '>
                      <FormSelect
                        type='text'
                        label={'Intended Share Registration Type'}
                        name={`intendedShareRegistrationTypeId`}
                        onChange={(value: string) => {
                          handleChange(value);
                        }}
                        errors={errors}
                        touched={touched}
                        options={transactionIntendedShareRegistrationsOptions}
                        isLoading={transactionIntendedShareRegistrationsOptionsLoading}
                        values={values}
                        arrValue={values?.intendedShareRegistrationTypeId}
                        setFieldValue={setFieldValue}
                        containerClassName='formGroup'
                        required
                      />
                    </div>
                  </div>
                  <div>
                    <Button
                      // btnClassName='mt-[24px]'
                      title={`Save`}
                      type='submit'
                      variant={'primary'}
                      loading={isLoading}
                      disabled={
                        isLoading ||
                        values?.priceThreshold === '' ||
                        values?.transactionAcquisitionTypeId === null ||
                        values?.intendedShareRegistrationTypeId === null ||
                        isEqual(
                          {
                            ...values,
                            priceThreshold: Number(values?.priceThreshold?.replaceAll(',', '')),
                          },
                          transactionConfiguration
                        )
                      }
                    />
                  </div>
                </Form>
              );
            }}
          </Formik>
        )}
      </TransactionConfigContainer>
    </>
  );
};

export default TransactionConfig;
